import React, { useState } from "react";
import "./Footer.css";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ContactUsDialog from "../ContactUsDialog/ContactUsDialog";
import { HashLink as Link } from "react-router-hash-link";
import { useNavigate, useLocation } from "react-router-dom";

function Footer({ background, backgroundColor, style, className }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isAdventure = location.pathname.startsWith("/facilitate") || location.pathname.startsWith("/adventure");
  const isGear = location.pathname.startsWith("/educate") || location.pathname.startsWith("/gear");

  const getFooterClass = () => {
    const classes = ["Footer"];
    if (isAdventure) classes.push("Footer--adventure");
    else if (isGear) classes.push("Footer--gear");
    if (className) classes.push(className);
    return classes.join(" ");
  };

  const dynamicStyle = {
    ...(backgroundColor ? { backgroundColor } : {}),
    ...(background ? { background, backgroundImage: "none" } : {}),
    ...style,
  };

  const handleContactUsClick = () => {
    if (!dialogOpen) setDialogOpen(true);
  };

  return (
    <div className={getFooterClass()} style={dynamicStyle}>
      <div className="footerContainer">
        <div className="footerLogoContainer">
          <img
            src="/Assets/Donation/DonationHeader/amalgamateLogoo.svg"
            alt="AmalgaMate"
            className="footerLogo"
            onClick={() => navigate("/amalgamate")}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="footerLastRow">
          {location.pathname === "/amalgamate" ? (
            <Link to="#about" smooth style={{ all: "unset", display: "contents", cursor: "pointer" }}>
              <span className="footerLastRowText">About</span>
            </Link>
          ) : (
            <Link
              to="/amalgamate#about"
              smooth
              style={{
                all: "unset",
                display: "contents",
                cursor: "pointer",
              }}
            >
              <span className="footerLastRowText">About</span>
            </Link>
          )}
          <FiberManualRecordIcon
            sx={{ color: "#1d1d20", height: "12px", width: "12px" }}
          />
          <span className="footerLastRowText" onClick={handleContactUsClick}>
            Contact
          </span>
          <FiberManualRecordIcon
            sx={{ color: "#1d1d20", height: "12px", width: "12px" }}
          />
          <span
            className="footerLastRowText"
            onClick={() => navigate("/donate/voting-rules")}
          >
            Voting Rules
          </span>
          <FiberManualRecordIcon
            sx={{ color: "#1d1d20", height: "12px", width: "12px" }}
          />
          <span
            className="footerLastRowText"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>
          <FiberManualRecordIcon
            sx={{ color: "#1d1d20", height: "12px", width: "12px" }}
          />
          <span
            className="footerLastRowText"
            onClick={() => navigate("/terms-of-use")}
          >
            Terms of Use
          </span>
        </div>
        <div className="lastBorder"></div>
      </div>
      <ContactUsDialog open={dialogOpen} setDialogOpen={setDialogOpen} />
    </div>
  );
}

export default Footer;
